import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { AUTH } from "@/constants/testIds";
import { toast } from "sonner";
import { usePageTitle } from "@/hooks/usePageTitle";

const ROLES = [
  { v: "customer", l: "Customer (default)" },
  { v: "affiliate", l: "Affiliate / Sales partner" },
  { v: "vendor", l: "Vendor" },
  { v: "candidate", l: "Job candidate" },
];

export default function Register() {
  usePageTitle("Create account");
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", email: "", password: "", phone: "", role: "customer" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await register(f); toast.success("Welcome to WeAutomate!"); nav("/dashboard"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Sign up failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center py-20">
      <div className="w-full max-w-md mx-6">
        <div className="glass rounded-3xl p-8">
          <h1 className="font-display text-3xl tracking-tighter">Create account</h1>
          <p className="mt-2 text-sm text-white/60">Pick a role — we'll route you to the right experience.</p>
          <form onSubmit={submit} className="mt-8 space-y-4">
            <input data-testid={AUTH.registerName} required placeholder="Full name"
                   value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })}
                   className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 outline-none focus:border-[#9D4CDD]" />
            <input data-testid={AUTH.registerEmail} type="email" required placeholder="Email"
                   value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })}
                   className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 outline-none focus:border-[#9D4CDD]" />
            <input data-testid={AUTH.registerPassword} type="password" required placeholder="Password (min 8 chars)"
                   minLength={8} value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })}
                   className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 outline-none focus:border-[#9D4CDD]" />
            <input data-testid={AUTH.registerPhone} placeholder="Phone (optional)"
                   value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })}
                   className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 outline-none focus:border-[#9D4CDD]" />
            <select data-testid={AUTH.registerRole} value={f.role}
                    onChange={(e) => setF({ ...f, role: e.target.value })}
                    className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 outline-none focus:border-[#9D4CDD]">
              {ROLES.map((r) => <option key={r.v} value={r.v}>{r.l}</option>)}
            </select>
            <button data-testid={AUTH.registerSubmit} disabled={busy}
                    className="w-full px-6 py-3 rounded-full gradient-bg font-medium disabled:opacity-50">
              {busy ? "Creating…" : "Create account"}
            </button>
          </form>
          <div className="mt-6 text-sm text-white/60">
            Already have an account? <Link to="/login" className="text-accent hover:text-white">Sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
